// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".livehead{color:#fff;padding:13px}.text-primary{color:$primary}.default-input{input[type=number],input[type=password],input[type=text],input[type=url]{border:0;width:100%;margin:0 0 0;box-sizing:border-box;box-shadow:none!important;margin-top:12px;padding:8px 0 8px;&:active,&:focus,&:hover{border:0!important;box-shadow:none!important}}textarea{border:0;padding:5px 10px;&:active,&:focus,&:hover{border:0!important;box-shadow:none!important}}}", ""]);
// Exports
module.exports = exports;
